var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSlackActive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-slack-active-24x24",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,12.9990019 C7.89567632,12.9990019 7,14.0933798 7,15.4426925 L7,21.5553114 C7,22.9046241 7.89567632,23.9990019 9,23.9990019 C10.1043237,23.9990019 11,22.9046241 11,21.5553114 L11,15.4426925 C10.9992067,14.0933798 10.1035303,12.9990019 9,12.9990019 Z",
    id: "Path",
    fill: "#EFEFF0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.018962963,15.5180819 C0.018962963,16.9083665 1.14676023,18.0361637 2.53704483,18.0361637 C3.92732943,18.0361637 5.05512671,16.9083665 5.05512671,15.5180819 L5.05512671,13 L2.53904094,13 C2.53804288,13 2.53804288,13 2.53704483,13 C1.14676023,13 0.018962963,14.1277973 0.018962963,15.5180819 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.50396511,0.045785575 C8.50297383,0.045785575 8.50198255,0.045785575 8.50099128,0.045785575 C7.12014274,0.045785575 6,1.17358285 6,2.56386745 C6,3.95415205 7.12014274,5.08194932 8.50099128,5.08194932 L11,5.08194932 C11,3.65373879 11,4.00106043 11,2.55887719 C10.9990087,1.17058869 9.88183981,0.045785575 8.50396511,0.045785575 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.44418195,11.0361637 L8.55981025,11.0361637 C9.9081911,11.0361637 11.0019961,10.1404047 11.0019961,9.03616374 C11.0019961,7.93192276 9.9081911,7.03616374 8.55981025,7.03616374 L2.44418195,7.03616374 C1.0958011,7.03616374 0.00199610136,7.93192276 0.00199610136,9.03616374 C0.00199610136,10.1404047 1.0958011,11.0361637 2.44418195,11.0361637 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5130916,6 C20.1248031,6 19,7.12480312 19,8.51309162 L19,8.51808187 L19,11.0361637 L21.5160858,11.0361637 C22.9063704,11.0361637 24.0341676,9.90836647 24.0341676,8.51808187 C24.0341676,7.12779727 22.9063704,6 21.5160858,6 C21.5150877,6 21.5140897,6 21.5130916,6 L21.5130916,6 Z",
    id: "Path",
    fill: "#EFEFF0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,2.48738755 L13,8.6081758 C13,9.95523307 13.8956763,11.0477817 15,11.0477817 C16.1043237,11.0477817 17,9.95523307 17,8.6081758 L17,2.48738755 C17,1.14033028 16.1043237,0.0477816764 15,0.0477816764 C13.8956763,0.0477816764 13,1.14033028 13,2.48738755 L13,2.48738755 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0321715,21.4809201 C18.0321715,20.0916335 16.9053723,18.9648343 15.5160858,18.9648343 L13,18.9648343 L13,21.4829162 C13.0009981,22.8712047 14.1267992,23.9970058 15.5160858,23.9970058 C16.9053723,23.9970058 18.0321715,22.8702066 18.0321715,21.4809201 Z",
    id: "Path",
    fill: "#EFEFF0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5130266,13 L15.3973983,13 C14.0490175,13 12.9552125,13.895759 12.9552125,15 C12.9552125,16.104241 14.0490175,17 15.3973983,17 L21.5130266,17 C22.8614075,17 23.9552125,16.104241 23.9552125,15 C23.9552125,13.895759 22.8614075,13 21.5130266,13 L21.5130266,13 Z",
    id: "Path",
    fill: "#EFEFF0",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackActive);
export default __webpack_public_path__ + "static/media/slack-active.9ccbb417cb37c8d6b07ad68cf4ff2e3b.svg";
export { ForwardRef as ReactComponent };